// フロントエンド環境変数管理
// ===========================

// 環境検出ヘルパー
const detectEnvironmentUrls = () => {
  // まずは環境変数を優先
  let backendUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL;
  
  // 未設定の場合は自動検出
  if (!backendUrl) {
    const hostname = window.location.hostname;
    if (hostname.endsWith('.app.github.dev')) {
      backendUrl = `https://${hostname.replace('-3000.', '-3001.')}`;
    } else if (hostname === 'on-line-bar.com' || hostname.endsWith('.on-line-bar.com')) {
      // 本番環境: on-line-bar.com の場合はapi.on-line-bar.comを使用
      backendUrl = 'https://api.on-line-bar.com';
    } else {
      backendUrl = 'http://localhost:3001';
    }
  }
  
  return {
    backendUrl
  };
};

const environmentUrls = detectEnvironmentUrls();

// React環境変数はREACT_APP_プレフィックス付きで定義
const config = {
  // Stripe設定
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  },

  // Discord設定
  discord: {
    clientId: process.env.REACT_APP_DISCORD_CLIENT_ID
  },

  // API設定
  api: {
    baseUrl: environmentUrls.backendUrl,
    backendUrl: environmentUrls.backendUrl
  },

  // 環境設定
  env: {
    nodeEnv: process.env.REACT_APP_NODE_ENV || 'development',
    isDevelopment: process.env.REACT_APP_NODE_ENV === 'development' || process.env.NODE_ENV === 'development',
    isDevelopmentMode: process.env.REACT_APP_DEVELOPMENT_MODE === 'true',
    isTestMode: process.env.REACT_APP_TEST_MODE === 'true'
  }
};

// 必須環境変数の検証
const validateConfig = () => {
  // 開発・テストモードでは柔軟な検証を行う
  const isDevelopmentMode = config.env.isDevelopmentMode || config.env.isTestMode;
  
  if (isDevelopmentMode) {
    console.log('🧪 フロントエンド: 開発・テストモードで実行中');
    
    // 開発モードでは基本的な値のチェックのみ行う
    const requiredVars = [
      'stripe.publishableKey',
      'discord.clientId',
      'api.baseUrl'
    ];
    
    const problematicVars = requiredVars.filter(path => {
      const value = path.split('.').reduce((obj, key) => obj && obj[key], config);
      return !value || (typeof value === 'string' && (value.includes('your_') || value.includes('_here')));
    });
    
    if (problematicVars.length > 0) {
      console.warn('⚠️ 以下の設定がプレースホルダー値のままです:');
      problematicVars.forEach(varName => {
        console.warn(`   - ${varName}`);
      });
      console.warn('開発用の .env.development ファイルを使用することを推奨します。');
    }
    
    console.log('✅ フロントエンド環境変数の検証が完了しました（開発モード）。');
    return true;
  }
  
  // 本番モードでは厳密な検証
  const requiredVars = [
    'stripe.publishableKey',
    'discord.clientId',
    'api.baseUrl'
  ];

  const missingVars = requiredVars.filter(path => {
    const value = path.split('.').reduce((obj, key) => obj && obj[key], config);
    return !value;
  });

  if (missingVars.length > 0) {
    console.error('❌ 以下の設定が不足しています:');
    missingVars.forEach(varName => {
      console.error(`   - ${varName}`);
    });
    console.error('\n.envファイルを確認してください。');
    return false;
  }

  if (config.env.isDevelopment) {
    console.log('✅ フロントエンド環境変数の検証が完了しました（開発モード）。');
  }
  
  return true;
};

// 設定の初期化と検証
validateConfig();

export default config;
export { config, validateConfig };
